module.exports = __webpack_public_path__ + "static/img/1044_small.2a7605c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/1044_small.png
// module id = PcNy
// module chunks = 1